// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import AMap from 'vue-amap'
Vue.use(AMap)
import App from './App'
import router from './router'
Vue.config.productionTip = false
import ElementUI  from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
let {MessageBox,Loading,Message} = ElementUI;
import jquery from 'jquery';
import './jquery'
import axios from 'axios'
Vue.prototype.m7$ = jquery;
Vue.prototype.$IFRAME_LINK = 'http://hotline.yunmeo.com/html/main.html';
//Vue.prototype.$IFRAME_LINK = 'http://wangxiaogang.yunmeo.com/html/main.html';
//Vue.prototype.$IFRAME_LINK = 'http://dongdong.yunmeo.com/ceshi/html/main.html';
import 'font-awesome/css/font-awesome.min.css'
import {post} from './api/http'
import store from './store'
import filters from './filter/filter'
import 'babel-polyfill'
import promise from 'es6-promise';
// 兼容 Promise
promise.polyfill();
import { Cookie, Local } from './util/storage'
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$ajax = axios;
Vue.prototype.$jquery = jquery
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$Cookie = Cookie;
Vue.prototype.$Local = Local;
Vue.prototype.$DOMAIN = 'http://www.china-chess.com:8083/';
Vue.prototype.$ADMIN_NAME = '心连心为民服务';
Vue.use(ElementUI)


// const plugin = ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'];
// AMap.initAMapApiLoader({
//   key: '5e1026117f9d0db212f49c257e216137',       // 必填
//   plugin:plugin,   // 如需使用定位等插件，则添加插件名
// });


import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if(!config || !config.retry) return Promise.reject(err);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if(config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err);
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, config.retryDelay || 1);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
        return axios(config);
    });
});

// 跳转
Vue.prototype.href = ( route, local ) => {
  route.push(local)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js